export { default } from "./IncomingCall";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/IncomingCall/index.js